module.exports = __webpack_public_path__ + "img/barrel.be5030ca.webp";